import { DateFormat } from "ui/common/types";

export const CASE_TABLE_VIEW_DATE_FORMAT: Intl.DateTimeFormatOptions = {
    year: DateFormat.Numeric,
    month: DateFormat.DoubleDigit,
    day:  DateFormat.DoubleDigit,
    hour: DateFormat.DoubleDigit,
    minute: DateFormat.DoubleDigit
};


